import script from "./widthMd.vue?vue&type=script&lang=js"
export * from "./widthMd.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__